<template>
  <nx-bform ref="form" @submit="onSubmit">
    <h5>
      {{ $t("title") }}
    </h5>
    <p class="text-muted">
      {{ $t("titleDesc") }}
    </p>

    <nx-bform-server-errors />

    <RegistrationContactAddressFormGroup
      label-cols="2"
      label-align="right"
      required
      v-model="form.address"
    />

    <RegistrationTelephoneFormGroup
      label-cols="2"
      label-align="right"
      required
      v-model="form.telephone"
    />

    <RegistrationHKIDNumberFormGroup
      label-cols="2"
      label-align="right"
      required
      v-model="form.idNo"
    />

    <RegistrationESignatureFormGroup
      label-cols="2"
      label-align="right"
      required
      v-model="form.eCert"
    />

    <b-form-group label-cols="2">
      <b-button type="submit" variant="primary" v-t="'send'" />
      <b-button class="ml-2" @click="resetForm" v-t="'cancel'" />
    </b-form-group>
  </nx-bform>
</template>

<script>
import { RequestRegistrationApi } from "@/api";
import { FileUtil } from "nx-libs";
import RegistrationContactAddressFormGroup from "@/forms/registration/RegistrationContactAddressFormGroup";
import RegistrationTelephoneFormGroup from "@/forms/registration/RegistrationTelephoneFormGroup";
import RegistrationHKIDNumberFormGroup from "@/forms/registration/RegistrationHKIDNumberFormGroup";
import RegistrationESignatureFormGroup from "@/forms/registration/RegistrationESignatureFormGroup";

export default {
  components: {
    RegistrationContactAddressFormGroup,
    RegistrationTelephoneFormGroup,
    RegistrationHKIDNumberFormGroup,
    RegistrationESignatureFormGroup
  },
  props: {
    invitationKey: {
      type: String
    }
  },
  data() {
    return {
      form: this.getForm()
    };
  },
  methods: {
    getForm() {
      return {
        address: "",
        telephone: "",
        idNo: "",
        eCert: null
      };
    },
    async onSubmit() {
      const { form, invitationKey } = this;

      await RequestRegistrationApi.requestAccountExist({
        contactAddress: form.address,
        phone: form.telephone,
        hkidNumber: form.idNo,
        guid: invitationKey,
        eCert: await FileUtil.toBase64NoType(form.eCert)
      });

      await this.$store.dispatch("userStore/refresh");

      this.$router.push({ name: "Home" });
    },
    resetForm() {
      this.form = this.getForm();
      this.$refs.form.reset();
    }
  }
};
</script>

<style lang="scss" scoped></style>

<i18n src="@/locales/actions.locale"></i18n>

<i18n>
{
  "en": {
    "title": "Application for registration as an assistant of Electronic Submission Hub",
    "titleDesc": "Since you have not registered as a assistant / professional user before, please complete the following application form. All fields with (*) are mandatory."
  },
  "zh_hk": {
    "title": "申請註冊為電子資料呈交及處理系統的協作者",
    "titleDesc": "由於您之前尚未註冊為助理/專業用戶，因此請填寫以下申請表。帶（*）的所有字段均為必填項。"
  },
  "zh_cn": {
    "title": "申请注册为电子资料呈交及处理系统的协作者",
    "titleDesc": "由于您之前尚未注册为助理/专业用户，因此请填写以下申请表。带（*）的所有字段均为必填项。"
  }
}
</i18n>
